export const hero2026Fragment = `
  fragment hero2026Fragment on Hero2026Record {
    bottomStripColor { backgroundColor }
    buttons { ...buttonFragment }
    cards {
      heading
      icon { ...iconFragment }
      subheading
    }
    description {
      blocks {
        ... on ListWithIconsBlockRecord { ...listWithIconsFragment }
      }
      links
      value
    }
    image {
      responsiveImage(
        imgixParams: {
          auto: format
          cornerRadius: "16"
          fit: crop
          h: 286
          mask: corners
          q: 45
          w: 464
        }
      ) { ...responsiveImageFragment }
    }
    logoHeading
    logos {
      id
      responsiveImage(
        imgixParams: { auto: format, fit: clip, h: 30, q: 45 }
      ) { ...responsiveImageFragment }
    }
    moduleFormat { ...moduleFormatFragment }
    overline { ...tagFragment }
    proofPoints { value }
    subtitle { ...highlightedTextFragment }
    testimonial {
      authorLinkedin
      authorName
      authorPhoto {
        responsiveImage(
          imgixParams: {
            auto: format
            cornerRadius: "40"
            fit: crop
            h: 40
            mask: corners
            q: 45
            w: 40
          }
        ) { ...responsiveImageFragment }
      }
      authorTitle
      datePublished
      quote
      stars
    }
    title { ...highlightedTextFragment }
    video { ...cmsVideoFragment }
  }
`;
